// modal.service.ts
import { ComponentFactoryResolver, Injectable, TemplateRef, Type } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AppModalComponent } from '../shared/components/app-modal/app-modal.component';


export interface ModalConfig {
    title?: string;
    componentInputs?: Record<string, any>;
    cleanUpFunction?: () => void;
    ngbOptions?: NgbModalOptions;
}

@Injectable({ providedIn: 'root' })
export class ModalService {
    constructor(private ngbModal: NgbModal,
        private cfr: ComponentFactoryResolver
    ) { }

    open(
        content: Type<any> | TemplateRef<any>,
        config: ModalConfig = {}
    ): NgbModalRef {
        const {
            title = 'Modal',
            componentInputs = {},
            ngbOptions = {},
            cleanUpFunction = () => { }
        } = config;

        const modalRef = this.ngbModal.open(AppModalComponent, {
            windowClass: 'fade',
            centered: true,
            ...ngbOptions,
        });

        // Pass config into the shell component
        const instance: AppModalComponent = modalRef.componentInstance;
        instance.title = title;
        instance.componentInputs = componentInputs;
        instance.cleanupFunction = cleanUpFunction;


        if (content instanceof TemplateRef) {
            instance.templateRef = content;
        } else {
            instance.componentFactory = this.cfr.resolveComponentFactory(content);
        }

        return modalRef; // caller can subscribe to .closed / .dismissed
    }

    close(instance: NgbModalRef) {
        instance.close();
    }

    closeActive() {
        this.ngbModal.dismissAll();
    }
}